import React, { useState, useContext } from "react";
import {useLocation, useNavigate, useParams} from "react-router-dom";
import AlertContext from "../../../../Context/Alert/AlertContext";
import { BaseURL } from "../../../../Files/BaseURL";
import ThemeContext from "../../../../Context/theme/ThemeContext";

const Step2 = () => {
  const { theme } = useContext(ThemeContext);
  const navigate = useNavigate();
  const location = useLocation();
  const { title, selectedCategory, selectedIndustry, selectedStyle, description, files } = location.state || {};

  const [price, setPrice] = useState("");
  const [flexible, setFlexible] = useState(false);
  const [deliveryDate, setDeliveryDate] = useState("");
  const [loading, setLoading] = useState(false);

  const alertcontext = useContext(AlertContext);
  const { showAlert } = alertcontext;

  const validateForm = () => {
    if (!price || !deliveryDate) {
      showAlert("Please fill in all fields", "danger");
      return false;
    }
    return true;
  };

  const handleSubmit = async () => {
    if (!validateForm()) {
      return;
    }

    const authToken = localStorage.getItem("p@token");

    const data = {
      DeliveryDate: deliveryDate,
      amount: price,
      flexible: flexible,
    };
    setLoading(true);

    // try {
    //   const response = await fetch(
    //     `${BaseURL}/api/requestjob/updateJob/${jobid}`,
    //     {
    //       method: "PUT",
    //       headers: {
    //         "Content-Type": "application/json",
    //         "auth-token": authToken,
    //       },
    //       body: JSON.stringify(data),
    //     }
    //   );
    //
    //   if (response.ok) {
    //     const result = await response.json();
        navigate(`/user-dashboard/create_request/request-overview/`,{
          state: {
            title,
            selectedCategory,
            selectedIndustry,
            selectedStyle,
            description,
            price,
            flexible,
            deliveryDate,
            files
      }
        });
    //   } else {
    //     const error = await response.json();
    //     console.error("Error:", error);
    //     showAlert("Failed to update job. Please try again.", "danger");
    //     setLoading(false);
    //   }
    // } catch (error) {
    //   console.error("Network Error:", error);
    //   showAlert("Network error. Please try again.", "danger");
    //   setLoading(false);
    // }
  };

  return (
    <div className="flex items-center font-pop flex-col">
      <div
        className={` rounded-2xl py-6 px-6 my-6 w-[95%] md:w-[70%] xl:w-[40%] flex flex-col gap-4
             ${theme === "dark" ? "bg-black text-white " : "bg-white"}`}
      >
        <h1 className="font-semibold text-xl text-center">Request a Job</h1>
        <div className="flex flex-col gap-4">
          <input
            type="number"
            id="price"
            name="price"
            value={price}
            onChange={(e) => setPrice(e.target.value)}
            placeholder="I’m looking to spend..."
            className={`w-full px-6 border-2 border-transparent font-pop text-base rounded-full bg-[#E8E8E8] py-2 focus:border-primarygreen focus:outline-none
                         ${
                           theme === "dark" ? "bg-black text-white border border-white" : "bg-white"
                         }`}
          />
          <div className="flex flex-row items-center gap-2 ml-2">
            <input
              type="checkbox"
              checked={flexible}
              onChange={(e) => setFlexible(e.target.checked)}
            />
            <p>My budget is flexible</p>
          </div>
          <input
            type="date"
            id="deliveryDate"
            name="deliveryDate"
            value={deliveryDate}
            onChange={(e) => setDeliveryDate(e.target.value)}
            className={`w-full px-6 border-2 border-transparent font-pop text-base rounded-full bg-[#E8E8E8] py-2 focus:border-primarygreen focus:outline-none
                            ${
                              theme === "dark"
                                ? "bg-black text-white border border-white" 
                                : "bg-white"
                            }`}
          />
          <button
            className={`my-4 px-2 md:px-6 bg-green-500 hover:bg-transparent hover:bg-white-500 font-medium hover:text-black font-pop text-sm md:text-lg py-2 md:py-3 border border-black-500 hover:border-green-500 rounded-full text-white   ${
              theme === "dark" ? "hover:text-white" : " hover:text-black"
            }`}
            onClick={handleSubmit}
          >
            {loading ? "Loading..." : "Review your brief"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Step2;
